
//15
Object.defineProperty(exports, "__esModule", { value: true });
require("../dropdown-option/DropdownOption.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "DropdownContent1942337714",
    {"root":"DropdownContent1942337714--root","optionsContainer":"DropdownContent1942337714--optionsContainer","dropdownOption":"DropdownContent1942337714--dropdownOption"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/dropdown-content/DropdownContent.st.css
// module id = 510
// module chunks = 0